<script setup lang="ts">
import { SubscriptionPlan } from '@/types';

import EnterprisePlan from './EnterprisePlan.vue';
import ProPlan from './ProPlan.vue';
import TrialStatusBanner from './StatusBanner.vue';

defineProps<{
    currentSubscriptionPlan: SubscriptionPlan;
    isTrial: boolean;
    isGracePeriod: boolean;
}>();
</script>

<template>
    <div class="mt-0 space-y-6">
        <div class="space-y-2">
            <h2 class="text-xl font-semibold">Choose a plan</h2>
            <p class="text-sm text-muted-foreground">
                Pick the plan that best suits your team.
            </p>
        </div>
        <TrialStatusBanner
            v-if="isTrial || isGracePeriod"
            :is-trial="isTrial"
            :is-grace-period="isGracePeriod"
        />

        <div class="grid gap-4 lg:grid-cols-2">
            <ProPlan
                :currentSubscriptionPlan="currentSubscriptionPlan"
                :is-trial="isTrial"
                :is-grace-period="isGracePeriod"
            />
            <EnterprisePlan
                :currentSubscriptionPlan="currentSubscriptionPlan"
            />
        </div>
    </div>
</template>
